function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgSecondSquareOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.756 11.12v.18H4.919v-.18h.234c.274 0 .472-.08.596-.24.078-.104.117-.355.117-.752V5.851c0-.336-.021-.557-.063-.664a.44.44 0 0 0-.2-.21.925.925 0 0 0-.45-.117H4.92v-.181h2.837v.18h-.24c-.27 0-.467.08-.59.24-.082.104-.122.355-.122.752v4.277c0 .335.02.557.063.664.033.082.101.152.205.21.14.078.288.117.445.117h.239ZM11.086 11.12v.18H8.249v-.18h.234c.274 0 .472-.08.596-.24.078-.104.117-.355.117-.752V5.851c0-.336-.02-.557-.063-.664a.44.44 0 0 0-.2-.21.925.925 0 0 0-.45-.117H8.25v-.181h2.837v.18h-.24c-.27 0-.466.08-.59.24-.082.104-.122.355-.122.752v4.277c0 .335.02.557.063.664.033.082.101.152.205.21.14.078.288.117.445.117h.239Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1H2v14h12V1ZM2 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H2Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgSecondSquareOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgSecondSquareOutlinedIcon);
export default Memo;